import moment from 'moment';

export const getTodayPromotions = (promotions) => {
  const todayPromotions = [];
  const dayOfTheWeek = moment().isoWeekday();

  for (let i = 0, promotionsLength = promotions.length; i < promotionsLength; i++) {
    if ((!promotions[i].daysOfWeek || promotions[i].daysOfWeek.indexOf(dayOfTheWeek) !== -1) && promotions[i].message) {
      todayPromotions.push(promotions[i].message);
    }
  }

  return todayPromotions;
};

export const getPromotionMessage = (promotions, page) => {
  if ((page === 'menu' || page === 'gallery') && promotions.menuPage && promotions.menuPage !== '') {
    return 'menuPage';
  } else if (page === 'preview' && promotions.previewPage && promotions.previewPage !== '') {
    return 'previewPage';
  } else if (page === 'confirmation' && promotions.confirmationPage && promotions.confirmationPage !== '') {
    return 'confirmationPage';
  } else {
    return 'null';
  }
};

export const showPromotionsBox = (promotions, page) => {
  if (page === 'confirmation' && promotions.confirmationPage && promotions.confirmationPage !== '') {
    return true;
  } else if (page === 'preview' && promotions.previewPage && promotions.previewPage !== '') {
    return true;
  } else if ((page === 'menu' || page === 'gallery') && (promotions.menuPage && promotions.menuPage !== '' || getTodayPromotions(promotions.messages).length > 0 && !promotions.replacePromotionText)) {
    return true;
  } else {
    return false;
  }
};

export const showTodayPromotions = (promotions, page) => !promotions.replacePromotionText && page !== 'preview' && page !== 'confirmation';



// WEBPACK FOOTER //
// ./helpers/promotions.helper.js